export default (max: number): number => {
  return Math.floor(Math.random() * max);
};
